import { styled } from '@mui/material';
import { Link as RouteLink } from 'react-router-dom';
import { SIDE_NAV_WIDTH } from 'src/constants';

export const Wrapper = styled('nav')(
  ({ theme }) => `
    position: fixed;
    top: 0;
    left: 0;
    overflow: auto;
    height: 100%;
    display: flex;
    flex-direction: column; 
    align-items: center;
    background: ${theme.palette.primary.main};
    width: ${SIDE_NAV_WIDTH}px;
    justify-content: space-between;

    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }

    svg {
      width: 40px;
      height: 40px;
    }
`,
);

export const Logo = styled('span')(
  ({ theme }) => `
    height: 40px;
    padding: 10px 0;
    path {
      fill: ${theme.palette.primary.contrastText}
    }
`,
);

export const Menu = styled('ul')`
  list-style: none;
  margin: 0;
  padding: 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Link = styled(RouteLink)(
  ({ $isSelected, theme }) => `
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        width: ${SIDE_NAV_WIDTH}px;
        min-height:84px;
        padding: 10px 12px;
        text-decoration: none;
        transition: background 0.1s ease-in-out, color 0.1s ease-in-out;
        font-size: 14px;
        font-weight: 500;
        line-height:1.33;
        font-family: Roboto;
        background: ${$isSelected && theme.palette.primary.contrastText};
        color: ${
          $isSelected
            ? theme.palette.primary.main
            : theme.palette.primary.contrastText
        };

        path {
          fill: ${
            $isSelected
              ? theme.palette.primary.main
              : theme.palette.primary.contrastText
          }
        }

        svg {
          width: 40px;
          height: 40px;
          margin-bottom: 8px;
        }
        
        &:hover {
            background: ${theme.palette.primary.contrastText};
            color: ${theme.palette.primary.main};

            path {
              fill: ${theme.palette.primary.main}
            }
        }
`,
);
